"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayHelperStyle = exports.DisplayHelperArray = void 0;

var _grid = require("../grid");

var DisplayHelperArray = ['block', 'inline-block', 'inline', 'flex', 'none', 'table-cell'];
exports.DisplayHelperArray = DisplayHelperArray;

var displayHelperStyle = function displayHelperStyle(display) {
  return (0, _grid.map)(display, function (d) {
    return d ? "display: ".concat(d, " !important;") : '';
  });
};

exports.displayHelperStyle = displayHelperStyle;